'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ListOwner = require('./components/ListOwner.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ListOwner).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/list-owner/index.js
// module id = 1044
// module chunks = 0